import React from "react";
import { useParams } from "react-router-dom";
import { useGetOrdersByIdQuery } from "../../../features/order/orderSlice";
import { Loader } from "../../../shared/Loader";
import { formatDateWithTimeAndDate } from "../../../utils/formatDate";
import CopyableOrderId from "@/components/CopyableOrderId";

export const TradeDetails = () => {
  let { id } = useParams();

  const {
    data: order,
    isLoading,
    isFetching,
    isError,
  } = useGetOrdersByIdQuery(id);

  console.log(order);

  return (
    <div className="font-dashboard pt-4 pb-12 md:px-4 min-h-screen">
      <div className="max-w-[700px] mx-auto relative">
        <div className="bg-black flex flex-col gap-4 px-4 lg:px-10 py-10 min-h-[85vh]">
          <h3 className="text-2xl text-white">Trade Details</h3>
          <hr className="border-white/10" />

          {isLoading || isFetching ? (
            <div className="w-full h-[70vh] flex justify-center items-center">
              <Loader />
            </div>
          ) : (
            <>
              <table className="flex flex-col gap-2">
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Transaction ID</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    <CopyableOrderId orderId={order?._id as string} />
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Type</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.type}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Placed By</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.user?.name}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Amount</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.quantity}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Rate Per USD</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.price}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Received Amount</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.total}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Crypto Rate</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.cryptoRate}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Amount In Crypto</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.totalInCrypto}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Order Status</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.status}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Created At</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {formatDateWithTimeAndDate(order?.createdAt as string)}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Updated At</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {formatDateWithTimeAndDate(order?.updatedAt as string)}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Terms / Code</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.note}
                  </td>
                </tr>
                <tr>
                  <td className="w-[200px]">
                    <p className="text-base text-white/70">Comment</p>
                  </td>
                  <td className="text-sm font-light text-white/40">
                    {order?.comment}
                  </td>
                </tr>
              </table>

              <div className="flex flex-col">
                <p className="text-base text-white/70">Images</p>

                <div className="w-full flex items-center flex-wrap">
                  {order?.images?.map((img, index) => (
                    <img src={img} alt={index.toString()} key={index} />
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
